import styled from 'styled-components';

export const AddAnswerButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
